import { useAppSelector } from "../store/index.ts";

export default function useNickname() {
  const telegramName = useAppSelector((state) => state.user.info.telegramName);
  const email = useAppSelector((state) => state.user.info.email);
  const nickname = email || telegramName || "Nickname";
  return nickname.includes("@") ? nickname : `@${nickname}`;
}
